import { SearchOutlined } from '@ant-design/icons'
import { Input, Skeleton, Typography } from 'antd'
import { Button, Loading, SharedTable } from 'src/common'
import { AppModal } from 'src/components/AppModal'
import { IBlogNewsItem } from 'src/interfaces/blog'
import { IHeadingType } from 'src/interfaces/evolve-landing-management'
import { useAddPostModal } from './useAddPostModal'
interface IProps {
  open: boolean
  listSelected: {
    postId: number
    index: number
  }[]
  title?: string
  onClose: () => void
  type: IHeadingType
  tabActive?: string
}
export const AddPostModal = ({
  open,
  onClose,
  title,
  listSelected,
}: IProps) => {
  const {
    blogs,
    totalBlogs,
    limitBlogs,
    pageBlogs,
    columns,
    getBlogs,
    searchValue,
    setSearchValue,
    isSearching,
    isChangingLibrary,
    numberSelected,
    isGettingListBlogs,
    onSave,
    disableRow,
  } = useAddPostModal({ listSelected })

  return (
    <AppModal
      open={open}
      onClose={() => {
        onClose()
      }}
      haveCloseIcon
      title={
        <div className="flex items-center justify-between pr-6">
          <Typography.Title level={3} className="!m-0 !text-[32px]">
            {title}
          </Typography.Title>
          <Button
            loading={isChangingLibrary}
            disabled={numberSelected !== 8}
            onClick={() => onSave(onClose)}
            type="primary"
            size="middle"
          >
            Save
          </Button>
        </div>
      }
      contentClassName="max-w-[95%] min-h-[90%]"
      childrenClassName="!mt-4"
    >
      {isGettingListBlogs ? (
        <Skeleton
          paragraph={{ rows: 4 }}
          style={{
            marginTop: 10,
          }}
          className=" !w-[95vw] 2xl:!w-[1400px]"
        />
      ) : (
        <div className="min-w-full 2xl:!w-[1400px]">
          <div className="flex justify-between items-center gap-x-4">
            <Input
              className="max-w-2xl h-10"
              prefix={<SearchOutlined className="pl-2" />}
              placeholder="Search title or author name"
              value={searchValue === null ? '' : searchValue}
              maxLength={50}
              onChange={(e) => {
                setSearchValue(e.target.value)
              }}
              suffix={isSearching ? <Loading /> : undefined}
            />
            <Typography.Text
              className={numberSelected === 8 ? '' : '!text-red-700'}
            >
              You must select exactly 8 items to display content:{' '}
              {numberSelected}
              /8
            </Typography.Text>
          </div>
          <SharedTable
            columns={columns as any}
            className="!ml-0"
            dataSource={blogs.map((item, index) => {
              return {
                index: index + 1,
                key: item?.id,
                id: item?.id,
                status: item?.published ? 'Published' : 'Unpublished',
                ...item,
              }
            })}
            rowClassName={(record: IBlogNewsItem, index) => disableRow(record)}
            paginationProps={{
              total: !!totalBlogs ? +totalBlogs : undefined,
              pageSize: +limitBlogs || 10,
              current: +pageBlogs,
              onChange(page) {
                const params: { page: number } = {
                  page: page,
                }
                getBlogs(params)
              },
            }}
            sticky
          />
        </div>
      )}
    </AppModal>
  )
}
